var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0a2.889 2.889 0 100 5.778A2.889 2.889 0 006.5 0zm0 7.944c-2.17 0-6.5 1.09-6.5 3.25v1.084c0 .398.324.722.722.722h4.664l.482-2.889-.121-.48a.776.776 0 111.506 0l-.121.48L7.614 13h4.664a.722.722 0 00.722-.722v-1.084c0-2.16-4.33-3.25-6.5-3.25z",
    fill: "#596F85",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructor);
export default __webpack_public_path__ + "static/media/instructor.8a9ff7aca14c0418a70616d789eab849.svg";
export { ForwardRef as ReactComponent };